/**
 * ApexChat.stringify is same as JSON.stringify, Its wraps the default JSON.stringify,
 * because many client's website can polute the JSON.stringify and we have observed this in ticket #CHAT-6786
 * @param {any} value
 * @param {any} replacer
 * @param {any} space
 */
const stringify = function (value, replacer, space) {
    // Checking Its Array Type or Normal JSON
    if (value && value.length) {
        const val = window.JSON.stringify(value, replacer, space);
        // JSON has quoted with invalid Inverted commas, we are removing it elsewise returning the same value.
        return val.match(/^".*/) ? val.substring(1, val.length - 1) : val;
    }
    return window.JSON.stringify(value, replacer, space);
};
export default stringify;
